import React from 'react'
import PlaceholderLayout from './placeholder_layout'

function VideoClipPlaceholder() {
  return (
    <PlaceholderLayout viewBox='0 0 110 180'>
      <rect x="0" y="0" rx="4" ry="0" width="110" height="180" />
    </PlaceholderLayout>
  )
}

export default VideoClipPlaceholder